import { createTheme } from '@mui/material/styles';

// Define the custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#D10000',
    },
    secondary: {
      main: '#C32026',
    },
    tertiary: {
      main: 'rgb(28, 47, 65)',
    },
    background: {
      default: 'rgb(28, 47, 65)',
    },
  },
  typography: {
    color: "#333333",
    h1: {
      fontSize: '2rem',
    },
    h2: {
      fontSize: '1.5rem',
    },
    h3: {
      fontSize: '20px',
    },
    h4: {
      fontSize: '18px',
    },
    h5: {
      fontSize: '1rem',
    },
    h6: {
      fontSize: '14px',
    },
    // body3: {
    //   fontSize: '22px',
    // },
    // body4: {
    //   fontSize: '36px'
    // },
    // body5: {
    //   fontSize: '24px'
    // },
  },
  components: {
    
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ccc",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ccc",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ccc",
            color: "#ccc",
          },
          "&.MuiInputLabel-root": {
            color: "#ccc",
          },
        },
      },
    },
  },
  spacing: 8,
});

export default theme;
